// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton_linkButton__j7nGn"};